import { Options } from 'types';
interface ActionType {
  GET_AUTHORISATION_START: string;
  GET_AUTHORISATION_SUCCESS: string;
  GET_AUTHORISATION_FAILURE: string;
  LIST_AUTHORISATIONS_START: string;
  LIST_AUTHORISATIONS_SUCCESS: string;
  LIST_AUTHORISATIONS_FAILURE: string;
  DELETE_AUTHORISATION_START: string;
  DELETE_AUTHORISATION_SUCCESS: string;
  DELETE_AUTHORISATION_FAILURE: string;
  UPDATE_AUTHORISATION_START: string;
  UPDATE_AUTHORISATION_SUCCESS: string;
  UPDATE_AUTHORISATION_FAILURE: string;
  ADD_AUTHORISATION_START: string;
  ADD_AUTHORISATION_SUCCESS: string;
  ADD_AUTHORISATION_FAILURE: string;
  ADD_AUTHORISATION_ORDER_START: string;
  ADD_AUTHORISATION_ORDER_SUCCESS: string;
  ADD_AUTHORISATION_ORDER_FAILURE: string;
  DELETE_AUTHORISATION_ORDER_START: string;
  DELETE_AUTHORISATION_ORDER_SUCCESS: string;
  DELETE_AUTHORISATION_ORDER_FAILURE: string;
  GET_AUTHORISATION_TYPES_START: string;
  GET_AUTHORISATION_TYPES_SUCCESS: string;
  GET_AUTHORISATION_TYPES_FAILURE: string;
  CLEAR_ALL_AUTHORISATIONS: string;
  CLEAR_SELECTED_AUTHORISATION: string;
  CLEAR_ERROR: string;
  PURCHASE_AUTHORISATION_START: string;
  PURCHASE_AUTHORISATION_SUCCESS: string;
  PURCHASE_AUTHORISATION_FAILURE: string;
  PURCHASE_AUTHORISATION_ORDER_START: string;
  PURCHASE_AUTHORISATION_ORDER_SUCCESS: string;
  PURCHASE_AUTHORISATION_ORDER_FAILURE: string;
  CLEAR_PURCHASE_AUTHORISATION: string;
}
export const AuthorisationActionTypes: ActionType = {
  GET_AUTHORISATION_START: '@@GET_AUTHORISATION_START',
  GET_AUTHORISATION_SUCCESS: '@@GET_AUTHORISATION_SUCCESS',
  GET_AUTHORISATION_FAILURE: '@@GET_AUTHORISATION_FAILURE',
  LIST_AUTHORISATIONS_START: '@@LIST_AUTHORISATIONS_START',
  LIST_AUTHORISATIONS_SUCCESS: '@@LIST_AUTHORISATIONS_SUCCESS',
  LIST_AUTHORISATIONS_FAILURE: '@@LIST_AUTHORISATIONS_FAILURE',
  DELETE_AUTHORISATION_START: '@@DELETE_AUTHORISATION_START',
  DELETE_AUTHORISATION_SUCCESS: '@@DELETE_AUTHORISATION_SUCCESS',
  DELETE_AUTHORISATION_FAILURE: '@@DELETE_AUTHORISATION_FAILURE',
  UPDATE_AUTHORISATION_START: '@@UPDATE_AUTHORISATION_START',
  UPDATE_AUTHORISATION_SUCCESS: '@@UPDATE_AUTHORISATION_SUCCESS',
  UPDATE_AUTHORISATION_FAILURE: '@@UPDATE_AUTHORISATION_FAILURE',
  ADD_AUTHORISATION_START: '@@ADD_AUTHORISATION_START',
  ADD_AUTHORISATION_SUCCESS: '@@ADD_AUTHORISATION_SUCCESS',
  ADD_AUTHORISATION_FAILURE: '@@ADD_AUTHORISATION_FAILURE',
  ADD_AUTHORISATION_ORDER_START: '@@ADD_AUTHORISATION_ORDER_START',
  ADD_AUTHORISATION_ORDER_SUCCESS: '@@ADD_AUTHORISATION_ORDER_SUCCESS',
  ADD_AUTHORISATION_ORDER_FAILURE: '@@ADD_AUTHORISATION_ORDER_FAILURE',
  DELETE_AUTHORISATION_ORDER_START: '@@DELETE_AUTHORISATION_ORDER_START',
  DELETE_AUTHORISATION_ORDER_SUCCESS: '@@DELETE_AUTHORISATION_ORDER_SUCCESS',
  DELETE_AUTHORISATION_ORDER_FAILURE: '@@DELETE_AUTHORISATION_ORDER_FAILURE',
  GET_AUTHORISATION_TYPES_START: '@@GET_AUTHORISATION_TYPES_START',
  GET_AUTHORISATION_TYPES_SUCCESS: '@@GET_AUTHORISATION_TYPES_SUCCESS',
  GET_AUTHORISATION_TYPES_FAILURE: '@@GET_AUTHORISATION_TYPES_FAILURE',
  PURCHASE_AUTHORISATION_START: '@@PURCHASE_AUTHORISATION_START',
  PURCHASE_AUTHORISATION_SUCCESS: '@@PURCHASE_AUTHORISATION_SUCCESS',
  PURCHASE_AUTHORISATION_FAILURE: '@@PURCHASE_AUTHORISATION_FAILURE',
  PURCHASE_AUTHORISATION_ORDER_START: '@@PURCHASE_AUTHORISATION_ORDER_START',
  PURCHASE_AUTHORISATION_ORDER_SUCCESS:
    '@@PURCHASE_AUTHORISATION_ORDER_SUCCESS',
  PURCHASE_AUTHORISATION_ORDER_FAILURE:
    '@@PURCHASE_AUTHORISATION_ORDER_FAILURE',
  CLEAR_PURCHASE_AUTHORISATION: '@@CLEAR_PURCHASE_AUTHORISATION',
  CLEAR_ALL_AUTHORISATIONS: '@@CLEAR_ALL_AUTHORISATIONS',
  CLEAR_SELECTED_AUTHORISATION: '@@CLEAR_SELECTED_AUTHORISATION',
  CLEAR_ERROR: '@@CLEAR_ERROR'
};
export interface AuthorisationState {
  authorisations: AuthorisationItem[];
  selectedAuthorisation?: AuthorisationItem;
  authorisationProcess?:
    | 'listing'
    | 'loading'
    | 'deleting'
    | 'updating'
    | 'updatingDone'
    | 'updatingFail'
    | 'adding'
    | 'addingDone'
    | 'addingFail'
    | 'purchasing'
    | 'purchasingDone'
    | 'purchasingFail'
    | 'clearField';
  authorisationOrderProcess?: 'loading' | 'deleting' | 'adding' | 'purchasing';
  authorisationPurchaseId?: number;
  authorisationPurchaseType?: string;
  authorisationPurchaseQuantity?: number;
  authorisationListingError?: string;
  totalAuthorisations?: number;
  orders: AuthorisationOrderAddPayload[];
  displayErrorMessage?: string;
  authorisationTypesOption?: Options;
}
export interface AuthorisationItem {
  id: number;
  name: string;
  channel: string;
  primaryContactEmail?: string;
  primaryContactName?: string;
  note?: string;
  externalId?: string;
  transactionsLeft?: number;
  expires?: string;
  authorisationType: string;
  createdAt: string;
  deletedAt?: string | null;
  ownerEmail?: string;
  users: string[];
  domains: string[];
  orders: AuthorisationOrder[];
}
export interface AuthorisationOrder {
  id: number;
  reference: string;
  amount: number;
  isMembershipAllowance: boolean;
  note?: string;
  expiredAt: string;
  createdAt: string;
  transactionCount: number;
  status: string;
}
export interface AuthorisationAddPayload {
  name: string;
  channel: string;
  authorisationType?: string;
  externalId: string | null;
  primaryContactEmail?: string | null;
  primaryContactName?: string | null;
  note?: string | null;
  users?: string[];
  domains?: string[];
  orders?: AuthorisationOrderAddPayload[];
}
export interface AuthorisationOrderAddPayload {
  id?: number;
  reference: string;
  amount: number;
  expiredAt: string;
  note?: string | null;
  isMembershipAllowance?: boolean;
}
export interface AuthorisationUpdatePayload {
  name: string;
  channel: string;
  externalId: string | null;
  primaryContactEmail?: string | null;
  primaryContactName?: string | null;
  note?: string | null;
  users?: string[];
  domains?: string[];
}
export interface AuthorisationUpdateActionPayload {
  id: number;
  payload: AuthorisationUpdatePayload;
}
export interface AddAuthorisationOrderStartNew {
  id: number;
  payload: AuthorisationOrderAddPayload;
}
